// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Input_inputContainer__1BnqC","input":"Input_input__3PNbO","inputValue":"Input_inputValue__y30sU","label":"Input_label__z-LP7","error":"Input_error__2VO4D"};